/* @flow */

import Cookies from 'js-cookie';

export function markOnboardingAsCompletedInCookie(secure?: boolean = true) {
  Cookies.set('onboarding_completed', true, {
    expires: 365,
    path: '/',
    secure,
  });
}
